import { type components } from '@heidi/schema/template-gallery';
import dynamic from 'next/dynamic';
import { type ReactNode } from 'react';

type GalleryFormField = components['schemas']['FormField'];

const FullscreenXmlFormPreviewModalImplementation = dynamic(
  () =>
    import('./FullscreenXmlFormPreviewModal-implementation').then(
      (module) => module.FullscreenXmlFormPreviewModalImplementation
    ),
  { ssr: false }
);

interface FullscreenXmlFormPreviewModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  xmlSource: string | null;
  formFields: GalleryFormField[];
  fieldValues: Record<string, string> | null;
  onDownload?: () => void;
  headerActions?: ReactNode;
}

export const FullscreenXmlFormPreviewModal = ({
  isOpen,
  onOpenChange,
  xmlSource,
  formFields,
  fieldValues,
  onDownload,
  headerActions,
}: FullscreenXmlFormPreviewModalProps) => {
  if (!isOpen) return null;

  return (
    <FullscreenXmlFormPreviewModalImplementation
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      xmlSource={xmlSource}
      formFields={formFields}
      fieldValues={fieldValues}
      onDownload={onDownload}
      headerActions={headerActions}
    />
  );
};
